<div class="container">
    <hr />
    <p style="text-align:center; font-size:14px">
        &copy; {{year}} Luna. All Rights Reserved.<br />
        <a routerLink="/privacy">Privacy Policy</a> |
        <a routerLink="/toc">Website Terms &amp; Conditions</a> |
        <a href="#" onclick="showAdChoices()">Ad Choices</a>
    </p>
</div>
